var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCallEndicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 66,
    height: 66,
    viewBox: "0 0 66 66",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_30722",
    "data-name": "Group 30722",
    transform: "translate(-155 -223)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_30728",
    "data-name": "Group 30728"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1604",
    "data-name": "Ellipse 1604",
    cx: 33,
    cy: 33,
    r: 33,
    transform: "translate(155 223)",
    fill: "#e3e3e3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_30729",
    "data-name": "Group 30729",
    transform: "translate(0.2 0.2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape_1",
    "data-name": "Shape 1",
    d: "M174.3,607.493a1.927,1.927,0,0,0,2.1-2.114c0-1-.01-1.982-.015-2.977a.437.437,0,0,1,.323-.5c.488-.109.981-.329,1.474-.432a21.719,21.719,0,0,1,7.053-.3,12.767,12.767,0,0,1,3.45.844.441.441,0,0,1,.3.473c-.048,1-.017,1.955-.012,2.951a2,2,0,0,0,2.169,2.188l2.353.012c.819,0,1.613.035,2.406.012a1.979,1.979,0,0,0,2.1-2.114c0-1-.01-1.982-.015-2.977a3.724,3.724,0,0,0-.884-2.431,9.78,9.78,0,0,0-3.484-2.47,25.83,25.83,0,0,0-8.541-2.193,27.387,27.387,0,0,0-11.7,1.378,13.84,13.84,0,0,0-4.636,2.515,3.816,3.816,0,0,0-1.4,3.193c.089.912.009,1.822.04,2.729a2.053,2.053,0,0,0,2.169,2.188Z",
    transform: "translate(-108.16 810.487) rotate(-135)",
    fill: "none",
    stroke: "#333",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22706",
    "data-name": "Path 22706",
    d: "M18,0,0,18",
    transform: "translate(177.5 247)",
    fill: "none",
    stroke: "#e3e3e3",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_260",
    "data-name": "Line 260",
    x1: 18,
    y2: 18,
    transform: "translate(178.5 247)",
    fill: "none",
    stroke: "#333",
    strokeLinecap: "round",
    strokeWidth: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallEndicon);
export default __webpack_public_path__ + "static/media/callEndicon.9e941349.svg";
export { ForwardRef as ReactComponent };